import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { getDriverName } from "../../../pages/Execute/CarrierAssigned/shipmentPage.util";
import { MODULES } from "../../../utils/constants";
import React from "react";
import { Persona } from "../persona/persona";
import { ShipmentDetails } from "../shipment-details/shipmentDetails";

import "./loadStops.scss";
import { RouteStops } from "./RouteStops";

export const StopDetailsWithRoute: React.FunctionComponent<any> = (
  props: any
) => {
  const loadDetails = props.loadDetails;
  const driverName = getDriverName(MODULES.INTRANSIT_MODULE, loadDetails);

  let loadStops: any[] = (loadDetails && loadDetails.loadStop) || [];
  loadStops =
    loadStops.slice().sort((load1: any, load2: any) => {
      if (load1.sequenceNo && load2.sequenceNo) {
        return load1.sequenceNo - load2.sequenceNo;
      }
      if (load1.stopSequence && load2.stopSequence) {
        return load1.stopSequence - load2.stopSequence;
      }
      return 0;
    }) || [];

  const loadStopsToShow: any[] = [];

  loadStops.forEach((load: any, index: number) => {
    if (index == 0 || index == loadStops.length - 1) {
      loadStopsToShow.push(load);
    }
  });

  return (
    <React.Fragment>
      <IonGrid class="stop-with-route-grid">
        <IonRow>
          <IonCol size="3" className="execution-shipment-dtls">
            <ShipmentDetails
              {...loadDetails}
              showLoadNo={false}
              isCarrierLoad={true}
            />
          </IonCol>
          <IonCol size="6" className="execution-stops-dtls">
            <RouteStops
              loadStops={loadStopsToShow}
              calculateTime={props.calculateTime}
            />
          </IonCol>
          <IonCol size="3" className="driver-persona-col">
            <div className="side-border"></div>
            <Persona showName={true} name={driverName} />
          </IonCol>
        </IonRow>
      </IonGrid>
    </React.Fragment>
  );
};
